import { profile } from "@/data/profile";
import { useLocale } from "@/i18n/locale";
import { ui } from "@/i18n/ui";
import { LocaleToggle } from "./LocaleToggle";
import { ThemeToggle } from "./ThemeToggle";

export const NAV_LINKS = [
  { href: "#work", label: ui.navWork },
  { href: "#experience", label: ui.navExperience },
  { href: "#skills", label: ui.navSkills },
  { href: "#about", label: ui.navAbout },
  { href: "#contact", label: ui.navContact },
] as const;

export function Nav() {
  const { t } = useLocale();

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-bg/80 backdrop-blur-md">
      <nav
        aria-label={t(ui.primaryNav)}
        className="mx-auto flex h-14 w-full max-w-5xl items-center justify-between gap-4 px-6"
      >
        <a href="#top" className="font-mono text-sm font-medium tracking-tight">
          {profile.domain}
        </a>

        <div className="flex items-center gap-1 sm:gap-2">
          <ul className="hidden items-center gap-1 sm:flex">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="rounded-sm px-2.5 py-1.5 text-sm text-muted transition-colors hover:text-text"
                >
                  {t(link.label)}
                </a>
              </li>
            ))}
          </ul>
          <LocaleToggle />
          <ThemeToggle />
        </div>
      </nav>
    </header>
  );
}
